import { Link } from "react-router-dom";
import { ArrowRight, Info } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../ui/dialog";
import { imgSet } from "../../data/portfolio";
import { trackEvent } from "../../lib/api";
import { InspirationBadge, inspirationChips, inspirationHref } from "./InspirationCard";

export const InspirationLightbox = ({ it, onClose }) => (
  <Dialog open={!!it} onOpenChange={(o) => !o && onClose()}>
    {it && (
      <DialogContent className="max-h-[92vh] max-w-5xl overflow-y-auto border-0 bg-white p-0 sm:rounded-2xl" data-testid="inspiration-lightbox">
        <div className="grid lg:grid-cols-5">
          <div className="relative bg-slate-100 lg:col-span-3">
            <img src={it.image.path} srcSet={imgSet(it.image.path)} sizes="(min-width: 1024px) 600px, 100vw" alt={it.image.alt || it.title} className="h-full max-h-[70vh] w-full object-cover lg:max-h-none" />
            <InspirationBadge it={it} className="absolute left-3 top-3" />
          </div>
          <div className="flex flex-col p-6 sm:p-7 lg:col-span-2">
            <DialogTitle className="font-display text-[22px] font-bold leading-snug text-ink">{it.title}</DialogTitle>
            <DialogDescription className="mt-2 text-[15px] leading-relaxed text-slate-600">{it.caption}</DialogDescription>
            <ul className="mt-4 flex flex-wrap gap-1.5">
              {inspirationChips(it).map((c) => <li key={c} className="rounded-full bg-slate-100 px-2.5 py-1 text-[12.5px] font-medium text-slate-700">{c}</li>)}
            </ul>
            <p className="mt-5 flex gap-2 rounded-xl bg-amber-50 p-3 text-[13px] leading-relaxed text-amber-900" data-testid="inspiration-disclaimer">
              <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
              {it.beeldtype === "illustratie" ? "Illustratie — geen foto en geen uitgevoerd project van Maas Kozijn." : "Inspiratiebeeld — geen uitgevoerd project van Maas Kozijn."} Het beeld toont een mogelijke uitvoering; wij adviseren wat bij uw woning past.
            </p>
            <Link to={inspirationHref(it)} onClick={() => trackEvent("cta_inspiration_click", { ref: it.ref, location: "lightbox" })}
              className="btn-cta mt-6 w-full !text-[15px]" data-testid="inspiration-lightbox-cta">
              Deze uitvoering spreekt mij aan — ontvang een prijsindicatie <ArrowRight className="h-5 w-5 shrink-0" aria-hidden="true" />
            </Link>
            <p className="mt-4 text-[12px] text-slate-400">Beeldnummer {it.ref}{it.credit ? ` · ${it.credit}` : ""}</p>
          </div>
        </div>
      </DialogContent>
    )}
  </Dialog>
);
